import {Avatar, Box, Stack, Typography} from "@mui/material";
import {IconWaveSine} from "@tabler/icons-react";
import {grey} from "@mui/material/colors";
import React from "react";
import AreaChart from "./AreaChart";

export const MiniCard = ({
                             subtitle,
                             title,
                             icon: Icon = IconWaveSine,
                             data = [],
                             color = "#3f51b5",
                             hideChart = false,
                         }) => {
    return (
        <Stack direction="column" gap={0} sx={{borderRadius: 3, p: 2, pb: 1}} className={"border-shadow"}>
            <Stack direction={"row"} gap={1.5} alignItems="center" sx={{pb: 1}}>
                <Avatar sx={{color: color, width: 32, height: 32, bgcolor: `${color}15`, fontSize: "1.1rem"}}
                        className={"border-shadow"}>
                    <Icon size={17}/>
                </Avatar>
                <Box>
                    <Typography variant={"body2"} color={grey[500]} sx={{lineHeight: 1.3}}>{subtitle}</Typography>
                    <Typography variant={"h5"} fontWeight={500} sx={{lineHeight: 1.3}}>{title}</Typography>
                </Box>
            </Stack>

            <Box id={"parent-box"} sx={{height: "90px", mx: -1, overflow: "hidden"}}>
                {hideChart ? null : <AreaChart data={data} colors={[color]} label={subtitle}/>}
            </Box>
        </Stack>
    )
}